import {PANELMANAGER_SET_PANEL_DIRTY} from '../../constants';

export type SetPanelDirtyAction = {
    type : typeof PANELMANAGER_SET_PANEL_DIRTY;
    panelKey : string;
    dirty : boolean;
}

/**
 * @memberOf! Actions
 *
 * @param {string} panelKey
 * @param {boolean} dirty
 *
 * @return {SetPanelDirtyAction}
 */
const setPanelDirty = ( panelKey : string, dirty : boolean ) : SetPanelDirtyAction => {
    return {
        type: PANELMANAGER_SET_PANEL_DIRTY,
        panelKey,
        dirty
    };
}
export type SetPanelDirty = typeof setPanelDirty;

export default setPanelDirty;
